import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getAttributeOrThrow, qsRequired } from '@/scripts/core/global'
import { type ProductFormContext } from '@/scripts/product-form-context/ProductFormContext'

// This is a generic class that can be used to create a custom element
// not for use in html directly

export class ProductFormGeneric extends UcoastEl {
	productId: string
	uniqueId: string

	constructor() {
		super()
		this.productId = getAttributeOrThrow('data-product-id', this)
		this.uniqueId = getAttributeOrThrow('data-unique-id', this)
	}

	getContext(): ProductFormContext {
		return qsRequired<ProductFormContext>(
			`product-form-context[data-product-id="${this.productId}"][data-unique-id="${this.uniqueId}"]`
		)
	}
}
